import { ExtendableImage } from '@design-system/extendable-image';
import classNames from 'classnames';
import React, { FC } from 'react';

import { CardMediaProps } from '../../models';

export const CardMedia: FC<CardMediaProps> = ({
  image,
  mediaVariant,
  children,
}) => (
  <div
    className={classNames('cds-card__media', {
      [`cds-card__media--variant-${mediaVariant}`]: mediaVariant,
    })}
  >
    {children}
    {image && <ExtendableImage {...image} className="cds-card__media-image" />}
  </div>
);
